<template>
  <router-view/>
</template>

<style>
 .no-scroll {
    overflow: hidden;
  }
</style>
